
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAreaGeometry",
      resolverType: "query",
      routePath: "/getAreaGeometry",
      httpMethod: "POST",
    });
  